<style lang="scss" scoped>
.text-xsmall {
  font-size: 60%;
}
</style>

<template>

  <v-layout column wrap>
    <v-icon :size="fontSize" class="emboss" :color="color">mdi-battery{{icon}}</v-icon>
    <small v-if="fontSize > 30" class="text-xs-center text-xsmall emboss white--text">{{battery}}</small>
  </v-layout>

</template>

<script>
export default {
  name: "battery",
  props: ['type', 'voltage', 'size'],
  data() {
      return {
        icon: '',
        color: '',
        fontSize: '',
        typeNum: null,
      }
  },
  created(){
    this.typeNum = this.type === 'minew' ? 1 : 0
    this.setIcon(this.typeNum)
  },
  watch: {
    voltage(){
      this.typeNum = this.type === 'minew' ? 1 : 0
      this.setIcon(this.typeNum)
    }
  },
  computed: {
    battery: function() {
      if (this.typeNum) {
        return parseFloat(this.voltage).toFixed(0) + '%'
      } else {
        return parseFloat(this.voltage).toFixed(2) + 'V'
      }
    }
  },
  methods: {
    setIcon(type) {
      const levels = [
        [2.7, 20],
        [2.8, 40],
        [2.9, 60],
        [3, 70],
        [3.1, 80],
        [3.2, 90],
        [3.3, 100],
      ]
      const voltage = parseFloat(this.voltage)
      switch (true) {
        case (voltage < levels[0][type]):
          this.icon = '-alert'
          this.color = 'deep-orange '
          break;
        case (voltage < levels[1][type]):
          this.icon = '-20'
          this.color = 'yellow darken-3'
          break;
        case (voltage < levels[2][type]):
          this.icon = '-50'
          this.color = 'yellow darken-1'
          break;
        case (voltage < levels[3][type]):
          this.icon = '-60'
          this.color = 'light-green lighten-1'
          break;
        case (voltage < levels[4][type]):
          this.icon = '-70'
          this.color = 'green lighten-2'
          break;
        case (voltage < levels[5][type]):
          this.icon = '-80'
          this.color = 'green lighten-1'
          break;
        case (voltage < levels[6][type]):
          this.icon = '-90'
          this.color = 'green darken-1'
          break;
        default:
          this.icon = ''
          this.color = 'green'
      }
      if (this.size) {
        if (this.size == 'xl') {
          this.fontSize = 50
        } else if (this.size == 'sm') {
          this.fontSize = 30
        } else if (this.size == 'xs') {
          this.fontSize = 20
        }
      } else {
        this.fontSize = 40
      }
    }
  }
}
</script>
